import { Component, effect, inject, ViewChild } from '@angular/core';
import { NgClass } from '@angular/common';  // AGREGAR ESTA LÍNEA
import { AppTitleService } from '../../services/app-title.service';
import { SelectionModel } from '@angular/cdk/collections';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ListadoDocumentoPaginado, Documento } from '../../models/Document';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { FormGroup, FormControl, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ScnackbarData, ToastService, SnackbarStyles } from '../../commons/toast.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { DocumentTypeService } from '../../services/document-type.service';
import { DocumentoService } from '../../services/documento.service';
import { DateService, MY_DATE_FORMATS } from '../../shared/date.service';
import { FilterData } from '../borrador/borrador.component';
import { DocumentType } from '../../models/DocumentType';
import { merge, startWith, switchMap, catchError, EMPTY, map, Observable, forkJoin } from 'rxjs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';

import { EstadosDocumentoComponent } from "../../commons/estados-documento/estados-documento.component";
import { CustomPaginator } from '../../commons/custom-paginator/custom-paginator';
import { NoDataFoundComponent } from "../../commons/no-data-found/no-data-found.component";
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { AutofocusDirective } from '../../helpers/autofocus.directive';
import { UtilService } from '../../services/util.service';
import { BuzonService } from '../../services/buzon.service';
import { Buzon } from '../../models/Buzon';
import { DlgConfirmComponent, DlgConfirmComponentData } from '../../commons/dlg-confirm/dlg-confirm.component';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-recibido',
  imports: [
    NgClass,  // AGREGAR ESTA LÍNEA
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatSnackBarModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    AutofocusDirective,
    MatDatepickerModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatProgressBarModule,
    EstadosDocumentoComponent,
    NoDataFoundComponent
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomPaginator },
    { provide: MAT_DATE_LOCALE, useValue: 'es-EC' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
  templateUrl: './recibido.component.html',
  styleUrl: './recibido.component.scss'
})
export class RecibidoComponent {
  displayedColumns: string[] = ['select', 'importante', 'movimiento', 'estados',  'asunto', 'fecha', 'buzon', 'numeroDocumento', 'usuarioAnterior'];
  documentsPaginated: ListadoDocumentoPaginado | undefined
  dataSource = new MatTableDataSource<Documento>([]);
  selection = new SelectionModel<Documento>(true, []);

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  resultsLength = 0;
  isLoadingResults = true;

  documentTypes: DocumentType[] | undefined
  buzones: Buzon[] | undefined

  dateRangeInWeeks = 5
  initialDate = "2025-01-02"
  maxDate = new Date()

  snackbarData: ScnackbarData = {}

  tipoBandeja = "1"

  filterForm = new FormGroup({
    fechaInicio: new FormControl(new Date(), {
      validators: [
        Validators.required
      ]
    }),
    fechaFin: new FormControl(new Date(), {
      validators: [
        Validators.required,
      ]
    }),
    searchText: new FormControl(""),
    documentType: new FormControl(""),
    idBuzon: new FormControl(""),
    numero: new FormControl('', [Validators.pattern('^(?:\\d{4}-)?\\d+$')]),
    state: new FormControl("",
      Validators.required
    )
  })

  contadorTareas = -1;
  utilService = inject(UtilService)

  tokenData = this.authService.getTokenData();

  constructor(
    private documentoSrv: DocumentoService,
    private documentTypeService: DocumentTypeService,
    private router: Router,
    public dialog: MatDialog,
    private toast: ToastService,
    private buzonService: BuzonService,
    private dateService: DateService,
    private authService: AuthService
  ) {
    inject(AppTitleService).setTitle('Recibidos');
     effect((e:any) => {
      const contTareas:any = this.utilService.signalTasks();
      if(!this.contadorTareas) { return}
      if (!contTareas.recibido) {
        return;
      }
      if (this.contadorTareas == -1) {
        this.contadorTareas = contTareas.recibido;
        return;
      }
      if (this.contadorTareas != contTareas) {
        this.contadorTareas = contTareas.recibido;
        this.reload();
      }
    });
  }

  ngOnInit(): void {
    const currentDate = new Date()
    let initialDate = new Date(this.initialDate)
    //initialDate.setDate(currentDate.getDate() - this.dateRangeInWeeks * 7)
    this.filterForm.controls.fechaFin.setValue(currentDate)
    this.filterForm.controls.fechaInicio.setValue(initialDate)
    this.filterForm.controls.state.setValue("0")
  }

  onKeyUp(e: Event) {
    const codeKey: any = e;
    codeKey.which !== 13
      ? e.preventDefault()
      : this.reload();
  }

  ngAfterViewInit(): void {

    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));

    forkJoin({
      buzones: this.buzonService.getBuzonesUsuario(),
      documentTypes: this.documentTypeService.list()
    }).subscribe({
      next: ({ buzones, documentTypes }) => {
        this.buzones = buzones;
        this.documentTypes = documentTypes;
        let documentTypeDescription = "Oficio"

        const defaultType = this.documentTypes.find(type => type.descripcion === documentTypeDescription);

        if (defaultType) {
          this.filterForm.controls.documentType.setValue("-1")
          this.filterForm.controls.idBuzon.setValue("-1")

          merge(this.sort.sortChange, this.paginator.page).pipe(
            startWith({}),
            switchMap(() => {
              this.isLoadingResults = true;
              const filterData = this.createFilterData()
              return this.documentoSrv!.getListadoDocumentosBandeja(
                this.tipoBandeja,
                filterData.initialDate,
                filterData.endDate,
                filterData.searchText,
                filterData.documentType,
                filterData.idBuzon!,
                "",
                this.paginator.pageIndex + 1,
              ).pipe(catchError(() => EMPTY));
            }),
            map(data => {
              this.isLoadingResults = false;
              if (data === null) {
                return [];
              }
              this.resultsLength = data.totalDocumentos;
              return data;
            })
          ).subscribe({
            next: (response) => {
              this.documentsPaginated = response as ListadoDocumentoPaginado
              this.dataSource = new MatTableDataSource<Documento>(this.documentsPaginated.documentos)

              Object.keys(this.filterForm.controls).forEach(controlName => {
                if (controlName !== "searchText" && controlName !== "numero") {
                  this.filterForm.get(controlName)?.valueChanges.subscribe(_ => {
                    this.reload();
                  });
                }
              });
            }
          })
        }
      }
    });
  }

  onClear(): void {
    this.filterForm.controls.searchText.setValue("")
    this.reload()
  }

  reload() {
    this.filterForm.controls.numero.setValue("");
    this.dataSource = new MatTableDataSource<Documento>([])
    this.fectchAndInitializeDataSource();
  }

  onKeyUpFlow(e: Event) {
    const codeKey: any = e;
    codeKey.which !== 13
      ? e.preventDefault()
      : this.buscarFlow();
  }

  buscarFlow() {
    this.filterForm.controls.searchText.setValue("")
    this.dataSource = new MatTableDataSource<Documento>([])
    this.fectchAndInitializeDataSource();
  }

  fectchAndInitializeDataSource() {
    this.paginator.pageIndex = 0
    const filterData = this.createFilterData()
    this.isLoadingResults = true;
    this.documentoSrv!.getListadoDocumentosBandeja(
      this.tipoBandeja,
      filterData.initialDate,
      filterData.endDate,
      filterData.searchText,
      filterData.documentType,
      filterData.idBuzon!,
      filterData.numero ? filterData.numero : null,
      this.paginator.pageIndex + 1,
    ).subscribe({
      next: (response) => {
        this.documentsPaginated = response as ListadoDocumentoPaginado
        this.dataSource = new MatTableDataSource<Documento>(this.documentsPaginated.documentos)
        this.resultsLength = this.documentsPaginated.totalDocumentos;
        this.isLoadingResults = false;
      }
    })
  }

  private createFilterData(): FilterData {
    const filterData: FilterData = {
      initialDate: this.dateService.formatDateToCustomString(this.filterForm.controls.fechaInicio.value!),
      endDate: this.dateService.formatDateToCustomString(this.filterForm.controls.fechaFin.value!),
      documentType: parseInt(this.filterForm.controls.documentType.value!),
      idBuzon: parseInt(this.filterForm.controls.idBuzon.value!),
      numero: this.filterForm.controls.numero.value?.toString() ?? undefined,
      searchText: this.filterForm.controls.searchText.value!
    }
    return filterData
  }

  reAsign() {
    if (this.selection.selected.length === 0) {
      this.snackbarData.message = "Seleccione al menos un documento!"
      this.snackbarData.style = SnackbarStyles.Warning
      this.snackbarData.iconName = "warning"
      this.toast.show(this.snackbarData)
      return
    }
    const taskData = {
      documentIDs: this.selection.selected.map(document => document.idTarea),
    }
    this.router.navigateByUrl("/documento/reasignar", { state: taskData })
  }

  archivar() {
    if (this.selection.selected.length === 0) {
      this.snackbarData.message = "Seleccione al menos un documento!"
      this.snackbarData.style = SnackbarStyles.Warning
      this.snackbarData.iconName = "warning"
      this.toast.show(this.snackbarData)
      return
    }
    const taskData = {
      documentIDs: this.selection.selected.map(document => document.idTarea),
    }
    this.router.navigateByUrl("/documento/archivar", { state: taskData })
  }

  onAddTask() {
    if (this.selection.selected.length === 0) {
      this.snackbarData.message = "Seleccione al menos un documento!"
      this.snackbarData.style = SnackbarStyles.Warning
      this.snackbarData.iconName = "warning"
      this.toast.show(this.snackbarData)
      return
    }
    const taskData = {
      documentIDs: this.selection.selected.map(document => document.idTarea),
    }
    this.router.navigateByUrl("tarea", { state: taskData })
  }

  onAddComment() {
    if (this.selection.selected.length === 0) {
      this.snackbarData.message = "Seleccione al menos una tarea"
      this.snackbarData.style = SnackbarStyles.Warning
      this.snackbarData.iconName = "warning"
      this.toast.show(this.snackbarData)
      return
    }
    const taskData = {
      documentIDs: this.selection.selected.map(document => document.idTarea),
    }
    this.router.navigateByUrl("comentar", { state: taskData })
  }

  clickedRow(row: any) {
    // 1. Definimos la lógica que queremos ejecutar después de la validación
    const proceedWithNavigation = () => {
      if (!row.leido || row.leido === 0 || row.idBuzon != null) {
        this.documentoSrv.marcarLeido(row.idTarea).subscribe({
          next: () => {
            row.leido = 1;
            this.utilService.callTasks();
            this.router.navigate(['/resumen', row.idTarea]);
          },
          error: (err) => console.error('Error marcando leído:', err)
        });
      } else {
        this.router.navigate(['/resumen', row.idTarea]);
      }
    };

    // 2. Lógica de validación de Buzón
    if (row.idBuzon && this.tokenData?.id != row.codigoParticipante) {
      const data: DlgConfirmComponentData = {
        title: "Reclamar documento de buzón?",
        message: "Documento compartido entre los suscritos al buzón. Seguro de continuar?",
        confirmLabel: "Si, continuar",
        closeLabel: "No"
      };

      const dialogRef = this.dialog.open(DlgConfirmComponent, {
        maxWidth: "40vw",
        width: "400px",
        data: data
      });

      dialogRef.afterClosed().subscribe((result: boolean) => {
        if (result) {
          proceedWithNavigation(); // Solo si confirmó
        }
      });
    } else {
      // 3. Si no es buzón o es el mismo participante, ejecutar directo
      proceedWithNavigation();
    }
  }


  setImportancia(event: any, row:any) {
    event.stopPropagation();
    const estado = row.importancia==0 ?1:0;
    this.documentoSrv.marcarImportancia(row.idTarea, estado).subscribe({
        next: () => {
          row.importancia = estado;
        },
        error: (err: any) => {
          console.error('Error:', err);
        }
      });
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource!.data.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }
    this.selection.select(...this.dataSource!.data);
  }

  checkboxLabel(row?: Documento): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}`;
  }

  formatDate(date: string): string {
    return this.dateService.formatCustomStringToDate(date)
  }

}
